/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ReadingIcon = /*#__PURE__*/ createSvgIcon(
  'ReadingIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.417 13.333c.652 0 1.288.073 1.906.22a9.164 9.164 0 011.844.655V6a7.138 7.138 0 00-1.813-.75 7.645 7.645 0 00-3.427-.104 7.221 7.221 0 00-1.427.437v8.25a9.453 9.453 0 011.448-.375 8.55 8.55 0 011.469-.125zm5.416.875a9.162 9.162 0 011.844-.656 8.55 8.55 0 013.375-.094c.48.084.962.209 1.448.375v-8.25a7.22 7.22 0 00-1.427-.437 7.68 7.68 0 00-3.427.104 7.137 7.137 0 00-1.813.75v8.208zM10 16.23a2.04 2.04 0 01-.552-.073 2.332 2.332 0 01-.49-.198 6.813 6.813 0 00-1.708-.718A7.066 7.066 0 005.417 15c-.584 0-1.157.076-1.72.23-.562.152-1.1.367-1.614.645-.291.153-.573.146-.844-.02a.805.805 0 01-.406-.73V5.083c0-.152.038-.298.115-.437a.72.72 0 01.344-.313 8.696 8.696 0 012-.75 9.074 9.074 0 012.125-.25A8.984 8.984 0 0110 4.583a8.984 8.984 0 014.583-1.25c.723 0 1.43.084 2.125.25a8.697 8.697 0 012 .75.72.72 0 01.344.313.895.895 0 01.115.437v10.042c0 .32-.136.563-.407.73-.27.166-.552.173-.843.02a7.547 7.547 0 00-1.615-.646A6.528 6.528 0 0014.583 15c-.625 0-1.236.08-1.833.24-.597.16-1.167.399-1.708.718-.153.084-.316.15-.49.198a2.039 2.039 0 01-.552.073z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ReadingIcon;
